import { createAsyncThunk } from '@reduxjs/toolkit';
import { message } from 'antd';
import { fetchApiAuth } from 'core/utils/api';
import { handleError } from 'core/utils/helpers';
import { CreateNewsPayload, PublishScheduledNewsPayload, UpdateScheduledNewsPayload } from './types';

export const getAllNews = createAsyncThunk(
    'news/getAllNews',
    async (_, { rejectWithValue }) => {
        try {
            const response = await fetchApiAuth({
                method: 'GET',
                url: '/news-article/all-news',
            });
            return response.data;
        } catch (error) {
            const errorMessage = handleError(error);
            message.error(errorMessage);
            return rejectWithValue(errorMessage);
        }
    },
);

export const createNews = createAsyncThunk(
    'news/create',
    async (payload: CreateNewsPayload, { rejectWithValue, dispatch }) => {
        try {
            const response = await fetchApiAuth({
                method: 'POST',
                url: '/news-article/create-news',
                body: payload,
            });
            message.success('News article created successfully');
            dispatch(getAllNews());
            return response.data.article;
        } catch (error) {
            const errorMessage = handleError(error);
            message.error(errorMessage);
            return rejectWithValue(errorMessage);
        }
    },
);

export const deleteNews = createAsyncThunk(
    'news/delete',
    async (articleId: number, { rejectWithValue, dispatch }) => {
        try {
            await fetchApiAuth({
                method: 'POST',
                url: '/news-article/delete-news-article',
                body: { id: articleId },
            });
            message.success('News article has been moved to trash');
            dispatch(getAllNews());
            return articleId;
        } catch (error) {
            const errorMessage = handleError(error);
            message.error(errorMessage);
            return rejectWithValue(errorMessage);
        }
    },
);

export const updateNews = createAsyncThunk(
    'news/update',
    async (payload: CreateNewsPayload & { id: number }, { rejectWithValue }) => {
        try {
            const response = await fetchApiAuth({
                method: 'POST',
                url: '/news-article/update',
                body: payload,
            });
            message.success('News article updated successfully');
            return response.data.article;
        } catch (error) {
            const errorMessage = handleError(error);
            message.error(errorMessage);
            return rejectWithValue(errorMessage);
        }
    },
);

export const publishScheduledNews = createAsyncThunk(
    'news/publishScheduled',
    async (payload: PublishScheduledNewsPayload, { rejectWithValue, dispatch }) => {
        try {
            const response = await fetchApiAuth({
                method: 'POST',
                url: '/news-article/publish-scheduled-news',
                body: payload,
            });
            message.success('Scheduled news article published successfully');
            dispatch(getAllNews());
            return response.data.article;
        } catch (error) {
            const errorMessage = handleError(error);
            message.error(errorMessage);
            return rejectWithValue(errorMessage);
        }
    },
);

export const updateScheduledNews = createAsyncThunk(
    'news/updateScheduled',
    async (payload: UpdateScheduledNewsPayload, { rejectWithValue, dispatch }) => {
        try {
            const response = await fetchApiAuth({
                method: 'POST',
                url: '/news-article/update-scheduled-news',
                body: payload,
            });
            message.success('Scheduled news article updated successfully');
            dispatch(getAllNews());
            return response.data.article;
        } catch (error) {
            const errorMessage = handleError(error);
            message.error(errorMessage);
            return rejectWithValue(errorMessage);
        }
    },
);
